module.exports = __webpack_public_path__ + "static/media/LifespanOfCivilizations.d28cd260.jpg";